export default (theme) => ({
  container: {
    alignItems: 'center',
    backgroundColor: '#fff',
    bottom: 0,
    display: 'flex',
    justifyContent: 'center',
    left: 0,
    overflowX: 'hidden',
    overflowY: 'hidden',
    position: 'absolute',
    right: 0,
    top: 0,
    zIndex: 2,
  },
  hide: {
    display: 'none',
  },
});
